import WebApp from "@twa-dev/sdk";
import { useLocation } from "wouter";
import React from "react";

const useTelegramNavigationObserver = () => {
  const [location] = useLocation();

  React.useEffect(() => {
    if (location === "/") {
      WebApp.BackButton.hide();
      WebApp.BackButton.offClick(() => {});
    } else {
      WebApp.BackButton.show();
      WebApp.BackButton.onClick(() => {
        history.back();
      });
    }
  }, [location]);
};

export default useTelegramNavigationObserver;
